import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-column-help-state',
  imports: [MatIconModule, TranslocoPipe],
  templateUrl: './column-help-state.component.html',
  styleUrl: './column-help-state.component.scss',
})
export class ColumnHelpStateComponent {}
